import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faWandMagicSparkles } from "@fortawesome/pro-solid-svg-icons";
import { faHouse } from "@fortawesome/pro-regular-svg-icons";
import useViewerContext from "@/services/context/viewer/instance/use-viewer-context";

import Card from "@/components/card/index.tsx";
import CheckBox from "@/components/checkbox";
import ProjectEditButton from "@/components/buttons/project-edit-button";

interface Calcul3PdfsuperposeCardActionProps {
    storeysFileDataHasScale: boolean;
    hasCalcul3: boolean;
    isLoading: boolean;
    onClick: () => void;
    onIndicatorCheckChanged: (indicatorKeyname: string, checked: boolean) => void;
}

const Calcul3PdfsuperposeCardAction: React.FC<Calcul3PdfsuperposeCardActionProps> = ({
    storeysFileDataHasScale,
    hasCalcul3,
    isLoading,
    onClick,
    onIndicatorCheckChanged
}) =>  {
    const { isLoading: isViewerLoading } = useViewerContext();

    if (hasCalcul3)
        return (
            <Card additionalContentClasses='flex flex-col gap-y-2 px-4 py-2 text-sm'>
                <ProjectEditButton variant='simple' size='sm'
                                     onClick={onClick}
                                     disabled={isLoading || !storeysFileDataHasScale}>
                    <div className='flex flex-row gap-x-2 items-center'>
                        <div className='flex flex-row gap-x-1 items-baseline'>
                            <FontAwesomeIcon icon={faHouse}/>
                            <FontAwesomeIcon icon={faWandMagicSparkles}/>
                            <FontAwesomeIcon icon={faCheck} className='text-green-500'/>
                        </div>
                        <span>Calcul automatique</span>
                    </div>
                </ProjectEditButton>

                <div>
                    <span>Visualisez dans l’arborescence</span>
                    <ul className='list-disc list-inside pl-2 text-sm'>
                        <li>Cloison & contre cloison</li>
                        <li>Pièce</li>

                        <div>
                            <CheckBox
                                disabled={isViewerLoading}
                                onChange={(e) =>
                                    onIndicatorCheckChanged('SHAB', e.target.checked)
                                }
                                checkedColors='checked:bg-[#90ee90] checked:border-[#90ee90]'
                            />
                            <span className='pl-3'>SHAB affinée</span>
                        </div>
                    </ul>
                </div>
            </Card>)

    return (
        <Card additionalContentClasses='flex flex-col gap-y-2 px-4 py-2 text-sm'>
            <ProjectEditButton variant='simple' size='sm'
                                 onClick={onClick}
                                 disabled={isLoading || !storeysFileDataHasScale}>
                <div className='flex flex-row gap-x-2 items-center'>
                    <div className='flex flex-row gap-x-1 items-baseline'>
                        <FontAwesomeIcon icon={faHouse}/>
                        <FontAwesomeIcon icon={faWandMagicSparkles}/>
                    </div>
                    <span>Calcul automatique</span>
                </div>
            </ProjectEditButton>

            <div>
                <span>Obtenez automatiquement</span>
                <ul className='list-disc list-inside pl-2 text-sm'>
                    <li>Cloison & contre cloison</li>
                    <li>Pièce</li>
                    <li>SHAB affinée</li>
                </ul>
            </div>
        </Card>
    )
};

export default Calcul3PdfsuperposeCardAction;